import { render, staticRenderFns } from "./BuyReport.vue?vue&type=template&id=2d7e5bfa&"
import script from "./BuyReport.vue?vue&type=script&lang=js&"
export * from "./BuyReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports